import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../toast/Toasts";
import { getRequestId } from "../../../_helpers/miscUtils";

export const bookingCancel = createAsyncThunk(
  "AirlineTicketCancellation/Air_TicketCancellation",
  async (formData: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineTicketCancellation/Air_TicketCancellation`,
        { ...formData, Request_Id }
      );
      if (response.data?.Response_Header?.Error_Code != "0000") {
        ErrorToast(
          response.data?.Response_Header?.Error_Desc ||
            "Something went wrong!"
        );
      } else {
        return response.data;
      }
    } catch (error: any) {
      ErrorToast(
        (error?.response?.data?.errors[0] &&
          error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!"
      );
      return Promise.reject({
        message:
          (error?.response?.data?.errors[0] &&
            error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!",
      });
    }
  }
);

export const addCancelBooking = createAsyncThunk(
  "FlightBooking/CancelFlightBooking",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightBooking/CancelFlightBooking`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(
        (error?.response?.data?.errors[0] &&
          error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!"
      );
      return Promise.reject({
        message:
          (error?.response?.data?.errors[0] &&
            error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!",
      });
    }
  }
);
